import * as process from 'process';

export const API_HOST = process.env.NEXT_PUBLIC_API_DOMAIN || '';

export const WECHAT_CODE = process.env.NEXT_PUBLIC_WECHAT_CODE || '';

export const DM_ZHONGWEN_URL = process.env.NEXT_PUBLIC_DM_ZHONGWEN_URL || '';

export const IEXERICISE = process.env.NEXT_PUBLIC_HOMEWORK_DOMAIN;

export const IS_PROD = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';

export const WECHAT_APPID =
  process.env.NEXT_PUBLIC_WECHAT_APPID || 'wxf3acbfbbdef5ddcd';

export const AUTH_REDIRECT_URI =
  process.env.NEXT_PUBLIC_AUTH_REDIRECT_DOMAIN || '';

export const COMMON_API_HOST = process.env.NEXT_PUBLIC_COMMON_API_DOMAIN || '';

export const GATEWAY_HOST = process.env.NEXT_PUBLIC_GATEWAY_HOST || '';

export const WK_GATEWAY_URL =
  process.env.NEXT_PUBLIC_WK_GATEWAY_API_DOMAIN || '';

export const CA_STUDIO_URL = process.env.NEXT_PUBLIC_CA_STUDIO_API_URL || '';

export const RS_GATEWAY_URL = process.env.NEXT_PUBLIC_RS_GATEWAY_API_HOST || '';

export const AGORA_URL = process.env.NEXT_PUBLIC_AGORA_URL ?? '';

export const CRM_API_HOST = process.env.NEXT_PUBLIC_CRM_API_HOST || '';

export const WUKONG_DOMAIN = process.env.WUKONG_DOMAIN || 'wktest';

export const payment_url = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    return window.location.href.includes('edu.net')
      ? 'https://pay.wukongedu.net'
      : 'https://pay.wukongsch.com';
  }

  return 'https://pay-test.wukongedu.net';
};

export const getReceiveAddressUrl = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    return 'https://wukongedu.net/wp/post-address';
  }
  return 'https://test.wukongedu.net/wp/post-address';
};

export const getCalendarSubscribeIcs = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    return 'stu-center.wukongacademy.com';
  }
  return 'stu-center-test.wukongedu.net';
};
/**
 * 判断是否是IE、Firefox、Opera浏览器
 * @returns 是否是IE、Firefox、Opera浏览器
 */
export const forbiddenBrowser = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return /msie/.test(ua) || /firefox/.test(ua) || /opera|opr/.test(ua);
};

export const getIsAndroid = (): boolean => {
  const u = window?.navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
};

export const isiPad = () => {
  const ua = navigator.userAgent;
  const isSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Version') !== -1;
  const isIphone = ua.indexOf('iPhone') !== -1 && ua.indexOf('Version') !== -1;
  return isSafari && !isIphone && 'ontouchend' in document;
};

export const isAndroidPad = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return getIsAndroid() && !/(?:Mobile)/.test(userAgent);
};

export const isTablet = () => {
  return isiPad() || isAndroidPad();
};

/**
 * 检测当前运行环境是否为服务端
 */
export const isServerSide = () => typeof window === 'undefined';

export const HOMEWORK_URL = () => {
  return window.location.href.includes('edu.net')
    ? process.env.NEXT_PUBLIC_HOMEWORK_DOMAIN
    : process.env.NEXT_PUBLIC_HOMEWORK_DOMAIN?.replace('edu.net', 'sch.com');
};

/**
 * 判断是否是App环境
 * @returns 是否是App环境
 */
export const isAppEnv = () =>
  typeof window !== 'undefined' && !!window?.AppBridge;
